<form novalidate id="cardPay" #cardPayForm="ngForm">
  <div class="flex flex-col gap-5">
    <div class="flex items-end gap-3">
      <div class="flex-grow-1 select-field w-full">
        <label class="required">Billing Address</label>
        <select
          required
          name="BillingAddress"
          [disabled]="isProcessing"
          [ngModel]="addressId"
          [class.invalid]="BillingAddress.invalid && isSubmitted && !addressId"
          (ngModelChange)="onAddressSelected($event)"
          #BillingAddress="ngModel"
        >
          <ng-container *ngFor="let address of customerAddresses">
            <option [ngValue]="address.Id">
              {{ getFullAddress(address) }}
            </option>
          </ng-container>
        </select>
      </div>

      <button
        cjButton
        type="button"
        class="!bg-blue-10 !text-blue-90 !border-blue-10"
        [disabled]="isProcessing"
        (click)="onAddressAdd.emit()"
      >
        <cj-icon icon="plus" pack="font-awesome-solid"></cj-icon>
        Add address
      </button>
    </div>

    <div class="flex items-end gap-3" *ngIf="customer && [2, 3].includes(customer.LevelProcessing)">
      <div class="flex-grow-1 select-field w-full">
        <label class="required">Shipping Address</label>
        <select
          required
          name="ShippingAddress"
          [disabled]="isProcessing"
          [ngModel]="addressShippingId"
          [class.invalid]="ShippingAddress.invalid && isSubmitted && !addressShippingId"
          (ngModelChange)="onAddressSelected($event, true)"
          #ShippingAddress="ngModel"
        >
          <ng-container *ngFor="let address of customerAddresses">
            <option [ngValue]="address.Id">
              {{ getFullAddress(address) }}
            </option>
          </ng-container>
        </select>
      </div>

      <button
        cjButton
        type="button"
        class="!bg-blue-10 !text-blue-90 !border-blue-10"
        [disabled]="isProcessing"
        (click)="onAddressAdd.emit(true)"
      >
        <cj-icon icon="plus" pack="font-awesome-solid"></cj-icon>
        Add address
      </button>
    </div>

    <ng-container *ngIf="!isInitializing">
      <ng-container *ngIf="!isAddCard">
        <div *ngIf="customerCards.length; else emptyCards">
          <label class="font-medium mb-2">Select Card</label>
          <cj-radio-group
            class="card-list"
            name="CustomerCard"
            [disabled]="isProcessing"
            [ngModel]="selectedCard.Id"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onSelectCard($event)"
          >
            <cj-radio
              *ngFor="let card of customerCards; let i = index"
              class="card-item" 
              [class.selected]="selectedCard?.Id === card.Id"
              [value]="card.Id"
            >
              <cj-icon class="text-cyan-60 mr-6" icon="cc-{{ card.CardBrand }}" pack="font-awesome-brands"></cj-icon>
              {{ card.CardBrand | uppercase }} ****{{ card.CardLast4Digits }}
            </cj-radio>
          </cj-radio-group>
        </div>
        <ng-template #emptyCards>
          <div class="card-none flex flex-col items-center justify-center p-4">
            <span class="text-gray-60 h-18 w-18 mb-2">
              <cj-svg-icon icon="no-customer-card"></cj-svg-icon>
            </span>
            <span class="font-italic font-medium text-gray-60">Customer have no cards saved</span>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="isAddCard">
        <app-heartland-card-tokenizer
          #tokenizerForm
          [publicAPIKey]="publicAPIKey"
          submitText="Process Payment"
          (tokenData)="onCardTokenReceived($event)"
        ></app-heartland-card-tokenizer>
      </ng-container>

      <button
        cjButton
        type="button"
        class="!bg-blue-10 !text-blue-90 !border-blue-10 self-start"
        [disabled]="isProcessing"
        (click)="onAddCard()"
      >
        <cj-icon icon="credit-card" pack="font-awesome-solid"></cj-icon>
        {{ !isAddCard ? 'Pay via new card' : 'Select card on file' }}
      </button>
    </ng-container>

    <cj-form-field
      *ngIf="invoiceSettings?.requireCvvVerification && selectedCard && !isAddCard"
      class="flex-grow-1 w-full"
    >
      <cj-form-label>Enter CVV/CVN For Verification</cj-form-label>
      <input
        cjInput
        fullWidth
        required
        name="CVV"
        autocomplete="off"
        pattern="\d+"
        [placeholder]="setCVVLength() === 3 ? '***' : '****'"
        [disabled]="isProcessing"
        [maxLength]="setCVVLength()"
        [status]="CardCVV.invalid && isSubmitted ? 'danger' : ''"
        [ngModel]="cardCVV"
        (ngModelChange)="onChange()"
        (keydown)="onCVVEntry($event)"
        #CardCVV="ngModel"
      />
    </cj-form-field>

    <cj-form-field class="flex-grow-1 w-full">
      <cj-form-label>Amount Due</cj-form-label>
      <input
        cjInput
        fullWidth
        readonly
        [value]="invoiceBalance | currency"
        [disabled]="isProcessing"
      />
    </cj-form-field>
  </div>
</form>

